import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import Get from "../services/Get";

const CandlestickChart = ({ symbol = "", interval = "1h" }) => {
  const [candles, setCandles] = useState([]);
  const [volume, setVolume] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const marketSymbol = String(symbol).replace(/[^a-z0-9]/gi, "").toUpperCase();

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    if (!marketSymbol) {
      setCandles([]);
      setLoading(false);
      return () => { active = false; };
    }
    Get.BinanceKlines(marketSymbol, interval, 120)
      .then((rows) => {
        if (active) {
          setCandles(rows.map((row) => ({
            x: new Date(Number(row[0])),
            y: [Number(row[1]), Number(row[2]), Number(row[3]), Number(row[4])],
          })));
          setVolume(rows.map((row) => ({
            x: new Date(Number(row[0])),
            y: Number(row[5]),
            fillColor: Number(row[4]) >= Number(row[1]) ? "#0ecb81" : "#f6465d",
          })));
        }
      })
      .catch((requestError) => {
        if (active) setError(requestError.message || "Candlestick data could not be loaded.");
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => { active = false; };
  }, [interval, marketSymbol]);

  const options = {
    chart: {
      type: "candlestick",
      height: 180,
      id: "candles",
      background: "transparent",
      foreColor: "#848e9c",
      toolbar: {
        autoSelected: "pan",
        show: true,
      },
      zoom: {
        enabled: true,
      },
    },
    title: {
      text: marketSymbol,
      align: "left",
      style: { color: "#eaecef", fontSize: "12px", fontWeight: 500 },
    },
    plotOptions: { candlestick: { colors: { upward: "#0ecb81", downward: "#f6465d" } } },
    grid: { borderColor: "#232832", strokeDashArray: 3 },
    tooltip: { theme: "dark" },
    xaxis: {
      type: "datetime",
      labels: { style: { colors: "#848e9c" } },
      axisBorder: { color: "#232832" },
      axisTicks: { color: "#232832" },
    },
    yaxis: {
      tooltip: {
        enabled: true,
      },
      labels: { style: { colors: "#848e9c" } },
    },
  };

  const volumeOptions = {
    chart: { type: "bar", height: 72, toolbar: { show: false }, sparkline: { enabled: true } },
    plotOptions: { bar: { columnWidth: "70%" } },
    dataLabels: { enabled: false },
    stroke: { width: 0 },
    tooltip: { x: { format: "dd MMM HH:mm" } },
    xaxis: { type: "datetime", labels: { show: false }, axisBorder: { show: false }, axisTicks: { show: false } },
    yaxis: { labels: { show: false } },
    grid: { show: false },
    colors: ["#2ebd85"],
  };

  return (
    <div className="terminal-apex-chart">
      {error ? <p role="alert" className="text-sm text-red-500">{error}</p> : loading ? <p className="text-sm text-gray-500">Loading chart…</p> : (
        <Chart options={options} series={[{ data: candles }]} type="candlestick" height={180} />
      )}
      {!error && !loading && volume.length > 0 && <Chart options={volumeOptions} series={[{ name: "Volume", data: volume }]} type="bar" height={36} />}
    </div>
  );
};

export default CandlestickChart;
